import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SearchContextType {
  searchQuery: string;
  setSearchQuery: (query: string) => void;
  isSearching: boolean;
  setIsSearching: (searching: boolean) => void;
  // 検索ハイライト機能を追加
  isHighlightMode: boolean;
  setIsHighlightMode: (highlight: boolean) => void;
  highlightQuery: string;
  setHighlightQuery: (query: string) => void;
}

const SearchContext = createContext<SearchContextType | undefined>(undefined);

export const useSearchContext = () => {
  const context = useContext(SearchContext);
  if (context === undefined) {
    throw new Error('useSearchContext must be used within a SearchProvider');
  }
  return context;
};

interface SearchProviderProps {
  children: ReactNode;
}

export const SearchProvider: React.FC<SearchProviderProps> = ({ children }) => {
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [isSearching, setIsSearching] = useState<boolean>(false);
  // 検索ハイライト機能の状態
  const [isHighlightMode, setIsHighlightMode] = useState<boolean>(false);
  const [highlightQuery, setHighlightQuery] = useState<string>('');

  // デバッグ: 検索状態の変化を監視
  const setSearchQueryWithLog = (query: string) => {
    setSearchQuery(query);
  };

  const setIsSearchingWithLog = (searching: boolean) => {
    setIsSearching(searching);
  };

  return (
    <SearchContext.Provider value={{ 
      searchQuery, 
      setSearchQuery: setSearchQueryWithLog, 
      isSearching, 
      setIsSearching: setIsSearchingWithLog,
      isHighlightMode,
      setIsHighlightMode,
      highlightQuery,
      setHighlightQuery
    }}>
      {children}
    </SearchContext.Provider>
  );
}; 